import { render, staticRenderFns } from "./ConflictPage.vue?vue&type=template&id=10b959cc&"
import script from "./ConflictPage.vue?vue&type=script&lang=js&"
export * from "./ConflictPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports